module.exports = __webpack_public_path__ + "static/media/add vehicle.86c6060d.svg";